import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LocalServiceService } from '../../../../shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-subadmin-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class SubAdminGalleryComponent implements OnInit {
  private modalRef: any;
  galleries: any;
  order_detail: any;
  imgUrl = environment.ImageUrl;
  description: string = '';
  totalItems: number = 0;
  totalPages: number = 0;
  currentPage: number = 1;
  filterType: string = 'new';

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.initData();
  }

  initData() {
    this.auth.shop_business_fetch({
      category: 'gallery',
      page: this.currentPage,
      limit: 12,
      filterType: this.filterType
    }).subscribe((response: any) => {
      this.galleries = response.body.data;
      this.totalItems = response.body.totalItems;
      this.totalPages = response.body.totalPages;
      this.currentPage = response.body.currentPage;
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }
    });
  }

  handleFilter() {
    this.currentPage = 1;
    this.initData();
  }

  previousPage() {
    this.currentPage--;
    this.initData();
  }

  nextPage() {
    this.currentPage++;
    this.initData();
  }

  openModal(content: any) {
    this.modalService.open(content, {
      windowClass: 'upload_file_modal custom-width mt-5',
      // backdrop: 'static',
      keyboard: false,
      size: 'xs',
    });
  }


  fileUpload: File | null = null
  thumbnail: string | null = null
  onFileSelected(event: any) {
    this.fileUpload = null
    this.thumbnail = null
    const file: File = event.target.files[0];
    if (file) {
      if (file.type.startsWith('image/')) {
        this.fileUpload = file
        // const reader = new FileReader();
        // reader.onload = (e: any) => {
        //   console.log('Data URL:', e.target.result);
        // };
        this.toastr.success(`Selected image file: ${file.name}`);
      } else {
        this.toastr.warning("Please select an image file");
      }
    } else {
      this.toastr.warning("No file selected");
    }
  }

  isUploading: boolean = false
  handleUpload() {
    if (this.fileUpload == null) {
      this.toastr.warning("No file selected");
      return;
    }

    const payload = new FormData();
    payload.append('file', this.fileUpload as Blob);
    payload.append('category', 'gallery');
    payload.append('description', this.description);

    this.isUploading = true

    this.auth.shop_business_store(payload)
      .subscribe((response: any) => {
        this.modalService.dismissAll()
        this.toastr.success('Uploaded successfully')
        this.isUploading = false
        this.initData()
        this.description = ''
      }, (e) => {
        this.toastr.error(e.error.message)
        this.isUploading = false
      })

  }

  handleDelete(id: any) {
    this.local.alertConfirm({ message: 'Are you sure you want to delete this gallery?' }).then((res: any) => {
      if (res.isConfirmed) {
        this.auth.shop_business_delete(id).subscribe((response: any) => {
          this.toastr.success('Deleted successfully')
          this.initData()
        }, (e) => {
          this.toastr.error(e.error.message)
        })
      }
    })
  }
}
